import { Badge } from '@/components/ui/badge';
import { Shield, Users, Crown, Lock, Eye } from 'lucide-react';
import { ContentAccessLevel } from '@/lib/utils/content-access';

interface ContentAccessIndicatorProps {
  accessLevel: ContentAccessLevel;
  className?: string;
}

export function ContentAccessIndicator({ accessLevel, className = '' }: ContentAccessIndicatorProps) {
  const getAccessConfig = (level: ContentAccessLevel) => {
    switch (level) {
      case ContentAccessLevel.PUBLIC:
        return {
          icon: Eye,
          label: 'Public',
          variant: 'secondary' as const,
          description: 'Available to all authenticated users'
        };
      case ContentAccessLevel.AUTHENTICATED:
        return {
          icon: Users,
          label: 'General',
          variant: 'default' as const,
          description: 'General Dominion Mandate content'
        };
      case ContentAccessLevel.EXTENDED:
        return {
          icon: Users,
          label: 'Extended',
          variant: 'outline' as const,
          description: 'Special events and archived content'
        };
      case ContentAccessLevel.LEADERSHIP:
        return {
          icon: Shield,
          label: 'Leadership',
          variant: 'secondary' as const,
          description: 'Leadership meetings and announcements'
        };
      case ContentAccessLevel.MEDIA:
        return {
          icon: Crown,
          label: 'Media Team',
          variant: 'secondary' as const,
          description: 'Media team and analytics content'
        };
      case ContentAccessLevel.ADMIN:
        return {
          icon: Lock,
          label: 'Admin Only',
          variant: 'destructive' as const,
          description: 'Administrative content only'
        };
      default:
        return {
          icon: Eye,
          label: 'Unknown',
          variant: 'outline' as const,
          description: 'Access level unknown'
        };
    }
  };

  const config = getAccessConfig(accessLevel);
  const Icon = config.icon;

  return (
    <Badge variant={config.variant} className={`flex items-center gap-1 text-xs ${className}`} title={config.description}>
      <Icon className="h-3 w-3" />
      {config.label}
    </Badge>
  );
}